import { WebApi } from '@/services/WebApi'

const state = () => ({
  resources: [],
  loadingResources: false,
  retryResources: false,
  attempted: false
})

const mutations = {
  setResources (state, resources) {
    state.resources = resources
  },
  setLoading (state, loading) {
    state.loadingResources = !!loading
    state.attempted = true
  },
  setRetry (state, retry) {
    state.retryResources = !!retry
  }
}

const actions = {
  getResourcesBySiteId ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('Portal/' + siteId + '/Resource')
        .then(response => {
          commit('setResources', response.data)
          resolve(response)
        })
        .catch(error => {
          commit('setRetry', true)
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
